import { render, staticRenderFns } from "./ProfileFilters.vue?vue&type=template&id=67268ce4&"
import script from "./ProfileFilters.vue?vue&type=script&lang=js&"
export * from "./ProfileFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67268ce4')) {
      api.createRecord('67268ce4', component.options)
    } else {
      api.reload('67268ce4', component.options)
    }
    module.hot.accept("./ProfileFilters.vue?vue&type=template&id=67268ce4&", function () {
      api.rerender('67268ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/filters/ProfileFilters.vue"
export default component.exports